import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/lantern-festival/2026/Index.vue')
const LotteryRewards = () => import('../activity/lantern-festival/2026/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/lantern-festival/2026',
  name: 'activity_lantern_festival_2026',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '蹦蹦跳跳闹元宵',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/lantern-festival/2026/lottery-rewards',
  name: 'activity_lantern_festival_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
